import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FilterSliceState } from './FilterType'

const initialState: FilterSliceState = {
    sortingBy: 'like_count',
    type: '2160p',
    minRating: "",
    ordering: 'desc',
}

export const FilterSlice = createSlice({
    name: 'filter',
    initialState: initialState,
    reducers: {
        setSortingBy: (state, action: PayloadAction<string>) => {
            state.sortingBy = action.payload
        },
        setType: (state, action: PayloadAction<string>) => {
            state.type = action.payload
        },
        setMinRating: (state, action: PayloadAction<string>) => {
            state.minRating = action.payload
        },
        setOrdering: (state, action: PayloadAction<string>) => {
            state.ordering = action.payload
        },
    },
})

export const { setSortingBy, setType, setMinRating, setOrdering } = FilterSlice.actions

export default FilterSlice.reducer;